import React from 'react';

export default function Logo({ variant = 'dark', className = 'h-8' }) {
  const src = variant === 'white' ? '/vinyled-logo-white.png' : '/vinyled-logo-dark.png';
  return (
    <img
      src={src}
      alt="VINYLED"
      className={`w-auto object-contain ${className}`}
    />
  );
}
